var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "selectRef", staticClass: "w-full h-full" },
    [
      _c(
        "button",
        {
          staticClass: "grm-cams-select-container w-full h-full",
          class: _vm.css,
          attrs: { disabled: _vm.disabled },
          on: { click: _vm.onToggleOpen },
        },
        [
          _c("div", { staticClass: "selected-name" }, [
            _vm._v(_vm._s(_vm.getName)),
          ]),
          _c("div", { staticClass: "icon-select-button" }),
        ]
      ),
      _vm.isOpenOptions && _vm.isMobile
        ? _c("GrmCamstudyOptionModal", {
            attrs: {
              list: _vm.list,
              position: _vm.position,
              name: _vm.name,
              value: _vm.value,
              title: _vm.title,
            },
            on: {
              onCloseOption: _vm.onCloseSelect,
              onNextAct: _vm.onSaveSelect,
            },
          })
        : !_vm.isMobile
        ? _c("div", [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isOpenOptions,
                    expression: "isOpenOptions",
                  },
                  {
                    name: "click-outside",
                    rawName: "v-click-outside",
                    value: _vm.onCloseSelect,
                    expression: "onCloseSelect",
                  },
                ],
                ref: "mobile-modal",
                staticClass: "desktop-modal",
                class: { "open-upward": _vm.shouldOpenUpward },
              },
              _vm._l(_vm.list, function (item, idx) {
                return _c(
                  "div",
                  {
                    key: idx,
                    staticClass: "modal-item",
                    on: { click: () => _vm.onSaveSelect(item.value) },
                  },
                  [_vm._v(_vm._s(item.name))]
                )
              }),
              0
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }